import { ACTIONS } from "./actions";

export const onOpenDialog = (dispatch: React.Dispatch<any>) => {
  dispatch({ type: ACTIONS.OPEN_DIALOG });
};

export const onCloseDialog = (dispatch: React.Dispatch<any>) => {
  dispatch({ type: ACTIONS.CLOSE_DIALOG });
};
